import {Box} from "@chakra-ui/react";
import RentalTable from "../../../components/tables/RentalTable";
import React, {useEffect, useState} from "react";
import {getData} from "../../../services/api";
import UserTable from "../../../components/tables/UserTable";

export default function Users() {

    const [tableData, setTableData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const columnsData = [
        {
            Header: "ID",
            accessor: "id",
        },
        {
            Header: "NAME",
            accessor: "fullname",
        },
        {
            Header: "EMAIL",
            accessor: "email",
        },
        {
            Header: "REGISTRIERT AM",
            accessor: "created_at",
        },
        {
            Header: "STATUS",
            accessor: "status",
        },
    ];

    useEffect(() => {
        // Define an async function to fetch data
        const fetchData = async () => {
            try {
                const result = await getData('/api/users');
                setTableData(result.data);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleDelete = (id) => {
        setTableData(prevData => prevData.filter(item => item.id !== id));
    };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
        {loading ? (
            <div>Loading...</div>
        ) : error ? (
            <div>Error: {error}</div>
        ) : tableData ? (
            <UserTable columnsData={columnsData} tableData={tableData} onDelete={handleDelete}/>
        ) : (
            <div>Keine Daten gefunden</div>
        )}
    </Box>
  );
}
